import React from "react";
import { LoadingDialog } from "../../../../_metronic/_partials/controls";
import {useAiReportsContext} from "../context/AiReportsContext";

export function AiReportsLoadingDialog() {
  const {loading} = useAiReportsContext();

  return <LoadingDialog isLoading={loading} />;
}